// vueform.config.(js|ts)

import en from '@vueform/vueform/locales/en'
import vueform from '@vueform/vueform/dist/vueform'
import { defineConfig } from '@vueform/vueform'
import axios from 'axios'

axios.defaults.headers.post = {
  'Content-Type': 'application/json'
}

en.validation.required = 'Please fill in :attribute field'

export default defineConfig({
  theme: vueform,
  locales: { en },
  locale: 'en',
  axios
})